import { DeliveryZone, DeliveryZoneBase } from '@flipdish/api-client-typescript';

export type DeliveryZonesDraftStatus = 'idle' | 'saving' | 'error' | 'conflict';

export type DeliveryZonesDraftState = Readonly<{
  status: DeliveryZonesDraftStatus;
  saveProgress: null | { current: number; total: number };
  dirty: boolean;
  storeId: number | null;
  pendingCreates: ReadonlyArray<{ clientId: string; zone: DeliveryZoneBase }>;
  pendingUpdates: Readonly<Record<number, DeliveryZone>>;
  pendingDeletes: ReadonlyArray<number>;
  lastError: string | null;
}>;

/**
 * One action for draft patch flows from map/list/create/remove.
 * Only include the fields relevant to each user gesture.
 */
/** Persisted-field patch for an existing server zone; Id is required. */
export type DeliveryZoneDraftUpdateExisting = DeliveryZoneBase & { Id: number };

export type DeliveryZoneDraftPatchPayload = Readonly<{
  storeId: number;
  /** Merge into pendingUpdates[zone.Id] (full snapshot per touched server id). */
  updateExisting?: DeliveryZoneDraftUpdateExisting;
  /** Append or replace by clientId in pendingCreates. */
  upsertPendingCreate?: { clientId: string; zone: DeliveryZoneBase };
  /** Server zone id to delete on Save. */
  addPendingDelete?: number;
  /** User reinstated a zone marked deleted — remove from pendingDeletes. */
  removePendingDelete?: number;
  /** Drop a not-yet-saved create. */
  removePendingCreate?: string;
}>;

/** ORM row overlaid with draft; optional markers for pending creates. */
export type DisplayDeliveryZone = DeliveryZone & {
  clientId?: string;
  isPendingCreate?: boolean;
};

export const initialDraftState: DeliveryZonesDraftState = {
  status: 'idle',
  saveProgress: null,
  dirty: false,
  storeId: null,
  pendingCreates: [],
  pendingUpdates: {},
  pendingDeletes: [],
  lastError: null,
};
